var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShedsHouseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.818,
    height: 32.228,
    viewBox: "0 0 53.818 32.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8928",
    "data-name": "Group 8928",
    transform: "translate(-378.891 -234.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8950",
    "data-name": "Path 8950",
    d: "M398.144,259.192v14.067",
    transform: "translate(1.482 -7.931)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8951",
    "data-name": "Path 8951",
    d: "M398.144,259.192v14.067",
    transform: "translate(14.069 -10.581)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8952",
    "data-name": "Path 8952",
    d: "M398.144,259.192v14.067",
    transform: "translate(26.655 -14.189)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8953",
    "data-name": "Path 8953",
    d: "M430.017,252.037l-36.589,9.771-6.7-4.574",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8954",
    "data-name": "Path 8954",
    d: "M430.017,255.645l-37.242,10.083-6.207-3.92",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8955",
    "data-name": "Path 8955",
    d: "M383.628,252.037l4.736,2.42v10.78l-7.351-4.736v-9.8Z",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8956",
    "data-name": "Path 8956",
    d: "M381.014,244.928l5.228-4.682,6.7,14.211-14.048-7.351Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8957",
    "data-name": "Path 8957",
    d: "M428.71,244.983v11.6",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8958",
    "data-name": "Path 8958",
    d: "M387.935,238.926l32.5-4.9,15.27,9.812-40.261,12.075Z",
    transform: "translate(-3 0.014)",
    fill: "#707070"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShedsHouseIcon);
export default __webpack_public_path__ + "static/media/shedsHouseIcon.bd72652a625e1a8ad989cd32bca924d9.svg";
export { ForwardRef as ReactComponent };